export const DSP_BILL_BATCH_PAYMENT_TEMPLATE_HEADER = '账单ID,是否完成付款(是),付款流程(1:线上对账付款/2:线下对账付款)';

export function buildDspBillBatchPaymentTemplate(): string {
  const BOM = '\uFEFF';
  return `${BOM}${DSP_BILL_BATCH_PAYMENT_TEMPLATE_HEADER}\r\n`;
}

export function downloadDspBillBatchPaymentTemplate(): void {
  const blob = new Blob([buildDspBillBatchPaymentTemplate()], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'DSP账单批量付款模板.csv';
  a.click();
  URL.revokeObjectURL(url);
}
